import { NAVIGATION_RECEIVE } from '../constants';
import { ContentLinkModel } from '../Types/ContentLinkModel';
import FloorHeatingCardProps from '../Components/FloorHeatingGuide/types/FHGuideCardProps';
import { AnyAction } from 'redux';

export interface NavigationState {
  contentLinks: ContentLinkModel[];
  rightContentLinks: ContentLinkModel[];
  logoUrl: string;
  phoneNumber?: string;
  fhGuide?: FloorHeatingCardProps;
  navigatorCTAHeaderButtonText?: string;
  navigationCTAModalHeader?: string;
  socialMediaLinks?: any[];
  mobileMenuOpen: boolean;
}

const DEFAULT_STATE: NavigationState = {
  contentLinks: [],
  rightContentLinks: [],
  logoUrl: '',
  mobileMenuOpen: false,
};

export const navigation = (
  state = DEFAULT_STATE,
  action: AnyAction
): NavigationState => {
  switch (action.type) {
    case NAVIGATION_RECEIVE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
